export default "__VITE_ASSET__f191662a__"